const PlanCard = ({ plan, price, features, contactOnly = false, onSelect }) => (
    <div className="bg-dark-100 p-6 rounded-lg shadow-md flex flex-col items-center justify-between">
        <div className="flex flex-col items-center">
            <h2 className="text-2xl font-bold mb-4">{plan}</h2>
            <p className="text-lg text-gray-400 mb-4">{plan === "Free Plan" ? "Essential features for individuals." : "Advanced features available."}</p>
            <p className="text-4xl font-extrabold mb-4">{price}</p>
            <ul className="list-disc list-inside text-gray-400 mb-6">
                {features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                ))}
            </ul>
        </div>

        {contactOnly ? (
            <button className="px-14 py-2 bg-purple text-white hover:bg-card-purple transition rounded-md">
                Contact Sales
            </button>
        ) : (
            <button onClick={onSelect} className="px-14 py-2 bg-purple text-white hover:bg-card-purple transition rounded-md">
                Subscribe
            </button>
        )}
    </div>
);

export default PlanCard;
